import React from 'react';
import collge1 from '../images/Pandit-L.R.-College-Logo-1.png';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faFacebook, faInstagram, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';

const FooterSection1 = () => {
  return (
    <div className='footer'>
      <div className='footer-main-container'>
        <div className='footer-main-container1'>
          <img src={collge1} alt="College Logo" className='imageofcollege' />
          <div className='address'>
            <ul className='unorderdlist-icon'>
              <li className='list-of-icon'>
                <FontAwesomeIcon icon={faLocationDot} size="2x" color='white'/>
                Sector-56, Kaboolpur Banger, Ballabgarh
              </li>
              <li className='list-of-icon'>
                <a href="tel:+919540028827">
                  <FontAwesomeIcon icon={faPhone} size="2x" />
                </a>Phone: +91 9540028827,9540028828
              </li>
              <li className='list-of-icon'>
                <a href="mailto:ptlrct@gmail.com">
                  <FontAwesomeIcon icon={faEnvelope} size="2x" />
              </a>Email: ptlrct@gmail.com
              </li>
              <li className='list-of-icon'>
                <a href="https://wa.me/919540028827">
                  <FontAwesomeIcon icon={faWhatsapp} size="2x"/></a> 
                  WhatsApp: +91 9540028827,9540028828

              </li>
            </ul>
          </div>
        </div>

        {/* Right Section: Follow Us */}
        <div className="footer-main-container2">
          <h3>Follow Us</h3>
          <ul className="wrapper">
            <li className="icon facebook">
              <span className="tooltip">Facebook</span>
              <a href="https://www.facebook.com/ptlrct" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebook} size="2x" color='#054be2'/>
              </a>
            </li>
            <li className="icon twitter">
              <span className="tooltip">Twitter</span>
              <a href="https://x.com/PTLRGROUP?t=BNjxxvkUKC3MIKt_rLzNxQ&s=09" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faTwitter} size="2x" color='#086caa'/>
              </a>
            </li>
            <li className="icon instagram">
              <span className="tooltip">Instagram</span>
              <a href="https://www.instagram.com/ptlrcollege?igsh=bnRteTRlNTNzZzVs" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faInstagram} size="2x" color='#e1306c' />
              </a>
            </li>
            <li className="icon whatsapp">
              <span className="tooltip">WhatsApp</span>
              <a href="https://wa.me/919540028827" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} size="2x" color='green' />
              </a>
            </li>
            <li className="icon youtube">
              <span className="tooltip">YouTube</span>
              <a href="https://youtube.com/@ptlrgroupofinstitutionsfar7153?si=HloVCPGmhotcp17n" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faYoutube} size="2x" color='red'/>
              </a>
            </li>
          </ul>
        </div>

        {/* Embed Google Map */}
        <div className="map-container">
          <iframe
            width="80%"
            height="400"
            frameBorder="0"
            style={{ border: 0 }}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7026.320891105488!2d77.23442613311283!3d28.293463471198386!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cd852dae7e85b%3A0x5817b9b9542ec60e!2sPt.%20L%20R%20Group%20of%20Institutions%20Faridabad%20Delhi%20NCR!5e0!3m2!1sen!2sin!4v1734669109433!5m2!1sen!2sin"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default FooterSection1;
